import axios from "axios";
import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import {PROPERTY_GOOGLE_REFRESH} from "../../../../constants/api.constants";
import {webComponentRefreshConstants} from "../../../../constants/Web/webComponentRefresh.constants";

const requestHeaders = () => ({
    'Content-Type': 'application/json',
    'authToken': getUserToken(),
    'language': getAppLang(),
});

// Harita gorseli ve Google yorumlari ayni uctan tazeleniyor; hangi isin yapilacagi
// `types` ile secilir. `force: true` servisteki 600 sn'lik throttle'i asar —
// kullanici butona bastiginda beklentisi aninda tazelenmesi.
const refreshRequest = (types) => axios.post(
    PROPERTY_GOOGLE_REFRESH,
    {params: {property_id: getProperty(), types, force: true}},
    {headers: requestHeaders()}
).then(response => response.data);

/**
 * Harita gorselini yeniden uretir.
 * Yanit: data.results.map.data.images
 */
export function refreshWebMap() {
    return dispatch => {
        dispatch({
            type: 'WEB_MAP_REFRESH',
            payload: refreshRequest(['map']),
        })
    }
}

/**
 * Google yorumlarini ve puanini yeniden ceker.
 * Yanit: data.results.review.data = {added, total, google_rating, google_rating_total}
 */
export function refreshWebReviews() {
    return dispatch => {
        dispatch({
            type: 'WEB_REVIEW_REFRESH',
            payload: refreshRequest(['review']),
        })
    }
}

export function clearWebComponentRefresh() {
    return dispatch => {
        dispatch({
            type: webComponentRefreshConstants.WEB_COMPONENT_REFRESH_CLEAR,
        })
    }
}
